var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('Loading'):_vm._e(),_c('BaseCheckbox',{attrs:{"label":"Gunakan Talangan Stok Reguler untuk Promo"},on:{"change":_vm.onChange},model:{value:(_vm.reimbursement_active),callback:function ($$v) {_vm.reimbursement_active=$$v},expression:"reimbursement_active"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }